import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'config/api';
import i18n from 'helpers/i18n';
import Immutable from 'immutable';
import Fade from '@material-ui/core/Fade';
// import Prettyfier from 'components/UI/Prettyfier';
// import HomeMember from './HomeMember';
// import HomeSpeaker from './HomeSpeaker';
import Header from '../Header/Header';
// import HeaderContent from "../Header/HeaderContent";
import Footer from '../Footer';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
// import { Redirect } from 'react-router-dom'
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { fetchData, getDataHome, getLoadingError } from '../../ducks/asyncFetcher';
import { isLoggedIn, getCurrentUserRole, getCurrentUser, isStateKnown } from 'ducks/authentication';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { primaryColor } from '../../helpers/colors';

const styles = (theme) => {
  return {
    root: {
      minHeight: '100%',
      height: '100%',
      width: '100%',
      maxWidth: '1280px',
      margin: '0 auto',
      color: theme.palette.primary.main,
    },
    fullHeight: {
      height: '100%',
    },
    // wrapper: {
    //   // maxWidth: '1280px',
    //   // margin: '0 auto',
    //   // height: '100%',
    //   width: '100%',
    //   minHeight: 'calc(100% - 150px)',
    //   // background: 'linear-gradient(180deg, rgba(241,243,244,0.42) 0%, rgba(223,227,229,0.42) 100%)',
    //   // borderBottom: '3px ' + primaryColor + ' solid',
    // },
    wrapper: {
      // minHeight: 'calc(100% - 360px - 150px)',
      minHeight: 'calc(100% - 134px)',
      // paddingLeft: theme.spacing(10),
      // paddingRight: theme.spacing(10),
      [theme.breakpoints.down('md')]: {
        // paddingLeft: theme.spacing(8),
        // paddingRight: theme.spacing(8),
        // height: 'auto',
        // minHeight: 'auto',
        // paddingLeft: theme.spacing(4),
        // paddingRight: theme.spacing(4),
      },
      [theme.breakpoints.down('sm')]: {
        // height: 'auto',
        // minHeight: 'auto',
        // paddingLeft: theme.spacing(2),
        // paddingRight: theme.spacing(2),
      },
      [theme.breakpoints.down('xs')]: {
        // paddingLeft: theme.spacing(1),
        // paddingRight: theme.spacing(1),
      },
    },
    content: {
    // paddingLeft: theme.spacing(10),
    // paddingRight: theme.spacing(10),
    },
    titleSmall: {
      fontSize: '2rem',
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.2rem',
        textAlign: 'center',
      },
    },
    headerImage: {
      textAlign: 'right',
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(2),
        textAlign: 'center',
      },
    },
    container: {
      height: '100%',
      minHeight: '940px',
      maxWidth: 'none',
    }
  };
};

class Template extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fixedSize: false,
    };
  }
  componentDidMount() {
    if (this.props.resize !== false)
    {
    this._onWindowResize();
    window.addEventListener('resize', this._onWindowResize);
    }
  }
  componendWillUnmount() {
    if (this.props.resize !== false)
    {
    window.removeEventListener('resize', this._onWindowResize);
  }
  }
  _onWindowResize = () => {
    const { classes } = this.props;
    const el = document.querySelector('#root');
    // console.log(el.offsetHeight, window.innerHeight)
    if (el.offsetHeight <= window.innerHeight) {
      el.style.height = window.innerHeight + 'px';
    } else {
      el.style.height = 'auto';
    }
  };
  render() {
    const { classes, title, children, current, headerImage, fixedSizeThreshold, maxWidth, maxHeight } = this.props;
    return (
      <Fade in timeout={1000} style={{height: maxHeight ? maxHeight : '100%', maxWidth: 'none', }}>
          <Container disableGutters
                  maxWidth={'false'}
                  className={classes.container}
                  >
            <ScrollToTopOnMount />
            <Grid container spacing={0} className={classes.root}>
              <Grid
                item
                xs={12}
                container
                alignContent="center"
                className={classes.main}
              >
              {children}
              </Grid>
            </Grid>
            <Footer className={classes.footer} colouredBackground={!isLoggedIn} />
          </Container>
      </Fade>

    );
  }
}

export default withRouter(withStyles(styles)(Template));



// WEBPACK FOOTER //
// ./src/components/Template/Template.jsx